module.exports = __webpack_public_path__ + "img/13.ded80b65.jpg";